import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import PageTitle from "../components/PageTitle/PageTitle";

const GroomHome = () => {

  return (
    <>
      <PageTitle title='उपवर' />
      <section className='vh_dashboard vh_home'>
        <Container>
          <Row className='justify-content-center align-items-center'>
            <Col md={4}>
              <div className='vh_card'>
                <div className='vh_right'>
                  <Link to='/groom-photo'>येथे पाहा</Link>
                </div>
                <img src='https://admin.lingayatyavatmal.com/assets/img/image.png' />
                <h2>Photo PDF</h2>
                <p>उपवर फोटो</p>
              </div>
            </Col>
            <Col md={4}>
              <div className='vh_card'>
                <div className='vh_right'>
                  <Link to='/groom-text'>येथे पाहा</Link>
                </div>
                <img src='https://admin.lingayatyavatmal.com/assets/img/pdf.png' />
                <h2>Text PDF</h2>
                <p>उपवर माहिती</p>
              </div>
            </Col>

            <Col md={4}>
              <div className='vh_card'>
                <div className='vh_right'>
                  <Link to='/groom-new-design'>येथे पाहा</Link>
                </div>
                <img src='https://admin.lingayatyavatmal.com/assets/img/pdf.png' />
                <h2>New Design PDF</h2>
                <p>उपवर फोटो व माहिती</p>
              </div>
            </Col>

            <Col md={4}>
              <div className='vh_card'>
                <div className='vh_right'>
                  <Link to='/grooms-excel'>येथे पाहा</Link>
                </div>
                <img src='https://admin.lingayatyavatmal.com/assets/img/sheet.png' />
                <h2>Excel</h2>
                <p>उपवर माहिती</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default GroomHome;
